<template>
    <div>
        <OcorrenciaInfo :idOcorrencia="idOcorrencia" @setActionCard="setActionCard" :isFinalizado="ocorrencia.flFinalizado" />
        <div class="container-fluid">
            <div class="row mt-3">
                <div class="col-12">
                    <DataTable v-if="url_solicitacoes != ''" :url_ajax="url_solicitacoes" :ajax_set_result="setTable" @grid_refreshed="gridRefreshed"
                               :refresh="refresh_grid" :filtros="filtro" method="GET" :qtd_registros_por_pagina="20" :is_table="true"
                               :footer_fixed="false" :headers="headers" :pBtnsSlot="true" :is_NotLoading="NotLoading"
                               :customHeight="lowHeightNoPage" :request_api="'comercial'">
                        <template v-slot:cell-slot="item">
                            <Card_Title class_color="bg-color-4" customSizeColorBorder="width:4px !important;max-width:4px !important;margin-bottom: -1px;">
                                <template v-slot:context>
                                    <div class="row">
                                        <div class="col-6">
                                            <label class="form-label"> Nome</label>
                                            <h5 class="card-dados">{{ item.row.nmPessoa }}</h5>
                                        </div>

                                        <div class="col-6">
                                            <label class="form-label"> Data da Solicitação</label>
                                            <h5 class="card-dados">{{ item.row.dtSolicitacao }}</h5>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-6">
                                            <label class="form-label"> Campanha</label>
                                            <h5 class="card-dados">{{ item.row.nmCampanha != null ? item.row.nmCampanha : '...' }}</h5>
                                        </div>

                                        <div class="col-6">
                                            <label class="form-label"> Origem</label>
                                            <h5 class="card-dados">{{ item.row.nmTipoOrigem != null ? item.row.nmTipoOrigem : '...' }}</h5>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-6">
                                            <label class="form-label"> E-mail</label>
                                            <h5 class="card-dados">{{ item.row.dsEmail }}</h5>
                                        </div>
                                        <div class="col-6">
                                            <label class="form-label"> Status</label>
                                            <div>
                                                <span class="text-danger" style="font-weight:bold;" v-if="item.row.flContatoFracassado">Sem Sucesso ! <br> <span style="color:black;">Motivo:</span> {{ item.row.dsMotivoFracasso }}</span>
                                                <span class="text-success" style="font-weight:bold;" v-else-if="item.row.idCortesia > 0">Cortesia Gerada !</span>
                                                <div v-else>
                                                    <button type="button" class="btn-fracassa-contato" @click="fracassa_contato(item.row.idSolicitacaoContato)">
                                                        <i class="fas fa-store-alt-slash"></i><span class="btn-span-text">Fracassar</span>
                                                    </button>
                                                    <button type="button" class="btn-grid-editar-lista" @click="func_crud(0, item.row.idInstituicao, item.row.idPessoa, 'SederCortesia')">
                                                        <i class="fas fa-address-card"></i><span class="btn-span-text">Gerar Cortesia Acesso</span>
                                                    </button>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                    </div>
                                </template>
                            </Card_Title>
                        </template>
                    </DataTable>
                </div>
            </div>
        </div>

        <modal-warper target="ModalFracassaContato" :show="isOpenModalFracassaContato" @close="(isOpenModalFracassaContato = false)">
            <Modal id="ModalFracassaContato" :size="''" :open="isOpenModalFracassaContato"
                   :customSizeWid="'width:600px;margin: 0 auto;padding-top:8rem;'" :FooterDefault="false"
                   :ClassBG="true" :customModalBody="'min-height:calc(100vh - 30rem);'">

                <template v-slot:header>
                    <h6 class="modal-title">
                        Fracassar Solicitação de Contato
                    </h6>
                    <button type="button" class="btn" data-bs-dismiss="modal" aria-label="Close">
                        <i class="fas fa-times btn-close-style-v2 hover-effect"></i>
                    </button>
                </template>

                <template v-slot:body>
                    <div>
                        <Form ref="Form_Fracassar_Contato" @submit="submit_fracassar_contato">
                            <div class="row mt-3">
                                <div class="col">
                                    <label class="form-label">Motivo do Fracasso</label>
                                    <vue-select :options="options_motivos_fracassos"
                                                :label-by="(e) => (e.dsMotivoFracasso)"
                                                v-model="motivo_fracasso"
                                                :class="{ filled: motivo_fracasso.idMotivoFracasso > 0 }"
                                                placeholder="Digite o motivo do fracasso e selecione"
                                                search-placeholder="Pesquise e selecione o motivo" searchable close-on-select clear-on-select
                                                :min="1" class="form-control shadow-v2">
                                    </vue-select>
                                    <Field name="idMotivoFracasso" label="Motivo" type="hidden" rules="min_value:1" v-model="motivo_fracasso.idMotivoFracasso" />
                                    <ErrorMessage name="idMotivoFracasso" class="form-error" v-show="showErrorMessage" />
                                </div>
                            </div>
                        </Form>
                    </div>
                </template>

                <template v-slot:footer>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-close-clean-v2 mt-2" data-bs-dismiss="modal">
                            Fechar
                        </button>
                        <button type="button" class="btn btn-red-v2"
                                v-on:click="submit_fracassar_contato">
                            <i class='fas fa-save pe-2'></i>
                            Fracassar Contato
                        </button>
                    </div>
                </template>

            </Modal>
        </modal-warper>


        <modal-warper target="ModalConfirmacao_set_cortesia" :show="isOpenModalConfirmacaoSetCortesia" @close="(isOpenModalConfirmacaoSetCortesia = false)">
            <ModalConfirmacao id="set_cortesia" :title="'Cortesia'" :show="isOpenModalConfirmacaoSetCortesia" :description="''" :red="'Deseja realmente Gerar a Cortesia?'" :action="'Gerar Cortesia'" @actionReturn="action_cortesia" :isDelete="false" />
        </modal-warper>
    </div>
</template>

<script>

    import axios from 'axios';
    import DataTable from '@/components/App/Datatable.vue'
    import ModalWarper from '@/components/App/ModalWarper.vue'
    import OcorrenciaInfo from '../../../../components/Tickets/Ocorrencia/Ocorrencia_Info.vue'
    import ModalConfirmacao from "@/components/App/ModalConfirmacao.vue";
    import $ from 'jquery';
    import Card_Title from '@/components/App/Card_Title.vue';
    import Modal from '@/components/App/Modal.vue'
    import VueNextSelect from 'vue-next-select'
    import 'vue-next-select/dist/index.min.css'

    export default {
        name: 'Agendamento',
        components: {
            'vue-select': VueNextSelect,
            DataTable,
            ModalWarper,
            OcorrenciaInfo,
            ModalConfirmacao,
            Card_Title,
            Modal
        },
        props: {
            idOcorrencia: {
                type: Number,
                default: 0
            },
            idModulo: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                isOpenModalConfirmacaoSetCortesia: false,
                isOpenModalFracassaContato: false,
                Cortesia: {},
                idInstituicao: 0,
                url_solicitacoes: '',
                refresh_grid: false,
                showErrorMessage: false,
                ocorrencia: {},
                filtro: [
                    { active: true },
                ],
                headers: [
                    { class: '', name: '', text: 'Solicitações de Acesso', actions: false, slot: true }
                ],
                NotLoading: false,
                setCortesiaCrud: {
                    idCortesia: 0,
                    idInstituicao: 0,
                    idPessoa: 0
                },
                idSolicitacaoContatoFracassa: 0,
                options_motivos_fracassos: [],
                motivo_fracasso: { idMotivoFracasso: 0 },
                lowHeightPage: '',
                lowHeightNoPage: '',
            }
        },
        methods: {
            updateLowHeight() {
                if (window.innerWidth <= 1600) {
                    this.lowHeightPage = 'max-height: calc(100vh - 20.8rem);min-height: calc(100vh - 20.8rem);margin-top:0px !important';
                    this.lowHeightNoPage = 'max-height: calc(100vh - 20rem);min-height: calc(100vh - 20rem);margin-top:0px !important';
                }
                else if (window.innerWidth >= 1601) {
                    this.lowHeightPage = 'max-height: calc(100vh - 20.8rem); min-height: calc(100vh - 20.8rem); margin-top: 0px!important';
                    this.lowHeightNoPage = 'max-height: calc(100vh - 20rem);min-height: calc(100vh - 20rem);margin-top:0px !important';
                }
            },
            submit_fracassar_contato() {
                let $this = this;

                var crud_fracassa = { idSolicitacaoContato: $this.idSolicitacaoContatoFracassa, idMotivoFracasso: $this.motivo_fracasso.idMotivoFracasso };

                $this.$refs.Form_Fracassar_Contato.validate()
                    .then(isValid => {
                        if (isValid.valid) {
                            axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/SolicitacaoContato/FracassaContato', crud_fracassa, { headers: $this.$api.getTokenComercial() })
                                .then(function (response) {
                                    $this.idSolicitacaoContatoFracassa = 0;

                                    $this.motivo_fracasso = { idMotivoFracasso: 0 };
                                    $this.reloadGrid();

                                    $this.isOpenModalFracassaContato = false;
                                })
                                .catch(function (error) {
                                    var msg = 'Ocorreu um erro inesperado';
                                    if (error.response) {
                                        if (error.response.data.erros != '') {
                                            msg = error.response.data.errors[0];
                                        } else {
                                            msg = error.response.data.msg;
                                        }
                                    }

                                    $this.$toast.show('alert', msg, true);
                                });
                            $this.showErrorMessage = false;
                        } else {
                            throw new Error();
                        }
                    })
                    .catch(error => {
                        var msg = 'Por favor, preencha todos os campos obrigatorios';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }
                        $this.showErrorMessage = true;
                        $this.$toast.show('alert', msg, true);
                    });

            },
            fracassa_contato(_idSolicitacaoContato) {
                let $this = this;
                $this.idSolicitacaoContatoFracassa = _idSolicitacaoContato;
                $this.isOpenModalFracassaContato = true;
            },
            getOcorrencia() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetId?id=' + $this.idOcorrencia, {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.ocorrencia = response.data.data;
                    $this.idInstituicao = $this.ocorrencia.idInstituicao;
                    $this.url_solicitacoes = $this.getUrlSolicitacoesContato();
                })
            },
            func_crud(idCortesia, idInstituicao, idPessoa, tpAlteracao) {
                this.setCortesiaCrud.idCortesia = idCortesia;
                this.setCortesiaCrud.idInstituicao = idInstituicao;
                this.setCortesiaCrud.idPessoa = idPessoa;
                if (tpAlteracao == 'SederCortesia') {

                    this.isOpenModalConfirmacaoSetCortesia = true;
                }
            },
            gridRefreshed(data_ajax) {
                let $this = this;
                $this.refresh_grid = false;
                $this.NotLoading = false;
            },
            reloadGrid() {
                let $this = this;
                $this.refresh_grid = true;
            },
            setTable(result) {
                $(result).each(function (index, element) {
                    if (element.dtUltimoLogin == null) {
                        element.dtUltimoLogin = '<i class="fas fa-times text-danger" style="font-size: 18px;"></i>';
                    } else {
                        element.dtUltimoLogin = '<i class="fas fa-check text-success" style="font-size: 18px;"></i>';
                    }
                });
                return result;
            },
            getUrlSolicitacoesContato() {
                return process.env.VUE_APP_ROOT_COMERCIAL_API + '/SolicitacaoContato/GetSolicitacoesContatoInstituicao?' + 'idModulo=' + this.idModulo + '&idInstituicao=' + this.idInstituicao;
            },
            action_cortesia() {
                let $this = this;

                if (this.setCortesiaCrud.idCortesia == 0) {
                    var request = { idOcorrencia: $this.idOcorrencia, idModulo: $this.idModulo, idPessoa: this.setCortesiaCrud.idPessoa, idInstituicao: this.setCortesiaCrud.idInstituicao };

                    axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/GeracaoCortesia/PostGerarCortesiaModuloInstituicaoPessoa', request, {
                        headers: this.$api.getTokenComercial()
                    }).then(response => {
                        $this.reloadGrid();
                    }).catch(error => {
                        var msg = 'Por favor, preencha todos os campos obrigatorios';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }
                        $this.showErrorMessage = true;
                        $this.$toast.show('alert', msg, true);
                    });
                }
            },
            setActionCard(action) {
                this.$emit('setActionCard', action);
            },
            getMotivosFracassos() {
                let $this = this;

                $this.options_motivos_fracassos = [];

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/SolicitacaoContatoMotivoFracasso/Get', {
                    headers: $this.$api.getTokenComercial(),
                    params: '',
                    notLoading: true
                }).then(response => {
                    $this.options_motivos_fracassos = response.data.data;
                })
            },
        },
        mounted() {
            this.getOcorrencia();
            this.getMotivosFracassos();
            this.updateLowHeight();

            window.addEventListener('resize', this.updateLowHeight);
        },
        updated() {
            this.updateLowHeight();
        },
        watch: {
            idOcorrencia(newVal, oldVal) {
                this.getOcorrencia();
            },
            idModulo(newVal, oldVal) {
            },
        },
    }

</script>

<style scoped>
    .selected {
        background: rgb(52, 168, 83) !important;
        color: white !important;
    }

    .card-dados {
        font-size: 14px;
    }

    .btn-grid-editar-lista {
        margin-left: 8px !important;
    }

    .btn-fracassa-contato {
        color: #B7413C;
        background: white;
        padding: 7px 12px !important;
        border-radius: 5px;
        font-weight: 500;
        font-size: 13px;
        border: 1px solid #B7413C;
    }

        .btn-fracassa-contato:hover {
            color: #B7413C;
            background: white;
            padding: 7px 12px !important;
            border-radius: 5px;
            font-weight: 500;
            font-size: 13px;
            border: 1px solid #B7413C;
        }

    .form-label {
        margin-bottom: 0 !important;
    }
</style>